'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { EntityTypes } from 'AdsUI/lib/Constants';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UILink from 'UIComponents/link/UILink';
import Raven from 'raven-js';

const Breadcrumb = ({
  adGroupId,
  network,
  onReturnToCampaign
}) => /*#__PURE__*/_jsxs(UIBreadcrumbs, {
  className: "p-left-0 m-bottom-2",
  singleBreadcrumbIsBackLink: false,
  children: [/*#__PURE__*/_jsx(UILink, {
    onClick: onReturnToCampaign,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `campaigns.campaignDetailsTable.labels.${network}.${EntityTypes.ADGROUP}`
    })
  }), /*#__PURE__*/_jsx("span", {
    children: adGroupId
  })]
});

const NoParentTable = ({
  network,
  adGroupId,
  onReturnToCampaign
}) => {
  Raven.captureMessage('User tried to access non-existent ad group', {
    level: 'info',
    extra: {
      network
    }
  });
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "CAMPAIGN_DETAILS_TABLE_LOADED",
    children: [/*#__PURE__*/_jsx(Breadcrumb, {
      adGroupId: adGroupId,
      network: network,
      onReturnToCampaign: onReturnToCampaign
    }), /*#__PURE__*/_jsx(UICardWrapper, {
      compact: true,
      className: "m-bottom-0",
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "notFound",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `campaigns.detailsErrors.noAdGroup.${network}`,
          options: {
            adGroupId
          }
        })
      })
    })]
  });
};

export default NoParentTable;